// REACT
import React, { Component } from 'react';

// COMPONENTS
import { FluidSection } from '../../components/FluidSection/index';
import { Content } from '../../components/Content';
import { Hero } from '../../components/Hero/index';

// UTILS
import { constants } from '../../constants/index';

class Contact extends Component {

  render() {
    return (
      <div style={constants.layout.container}>
        <Hero 
          backgroundImageURL={'https://firebasestorage.googleapis.com/v0/b/cyno-5e3a9.appspot.com/o/CynoGraphics%2Fapp%2Bweights-small.jpg?alt=media&token=a9b36965-cd29-43d5-9da7-eb720f750708'} 
          mainTitleText="Contact" 
          height={300} 
        />
          <FluidSection style={{ maxWidth: 800, marginBottom: -60, }} >
            <Content
              // style={{ marginRight: 40 }} 
              mainTitleTextAlt={"Have any question or concerns?"} 
              /> 
            </FluidSection>
            <FluidSection style={{ maxWidth: 800 }} >
              <Content
                // subTitleText={"Who we are"}
                style={{ marginBottom: 0, marginRight: 0, maxWidth: 500, }} 
                //  bodyText={''}
                //  ('<ul><li>Family Medicine</li><li>Physiotherapy</li><li>Personal training</li><li>Nutrition</li><li>Naturopath</li><li>Mental wellness</li><li>and many more…</li></ul>')
                >
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', }}>
                <p style= {{ marginRight: 10 }}>Contact us at:</p>
                <a style={{ textDecoration: 'none', color: 'rgb(74, 196, 209)' }} href="mailto:support@cyno.ca?subject=Question or Concern"> support@cyno.ca </a>
                </div>
              </Content> 
          </FluidSection>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/js/containers/Contact/Contact.jsx